import React from 'react';

const GeminiFill = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 20C9.9 20 9.80833 19.9667 9.725 19.9C9.64167 19.8333 9.58333 19.75 9.55 19.65C9.26667 18.5333 8.84167 17.4833 8.275 16.5C7.70833 15.5167 7.01667 14.6167 6.2 13.8C5.38333 12.9833 4.48333 12.2917 3.5 11.725C2.51667 11.1583 1.46667 10.7333 0.35 10.45C0.25 10.4167 0.166667 10.3583 0.1 10.275C0.0333333 10.1917 0 10.1 0 10C0 9.9 0.0333333 9.80833 0.1 9.725C0.166667 9.64167 0.25 9.58333 0.35 9.55C1.46667 9.26667 2.51667 8.84167 3.5 8.275C4.48333 7.70833 5.38333 7.01667 6.2 6.2C7.01667 5.38333 7.70833 4.48333 8.275 3.5C8.84167 2.51667 9.26667 1.46667 9.55 0.35C9.58333 0.25 9.64167 0.166667 9.725 0.1C9.80833 0.0333333 9.9 0 10 0C10.1 0 10.1875 0.0333333 10.2625 0.1C10.3375 0.166667 10.3917 0.25 10.425 0.35C10.725 1.46667 11.1583 2.51667 11.725 3.5C12.2917 4.48333 12.9833 5.38333 13.8 6.2C14.6167 7.01667 15.5167 7.70833 16.5 8.275C17.4833 8.84167 18.5333 9.26667 19.65 9.55C19.75 9.58333 19.8333 9.64167 19.9 9.725C19.9667 9.80833 20 9.9 20 10C20 10.1 19.9667 10.1917 19.9 10.275C19.8333 10.3583 19.75 10.4167 19.65 10.45C18.5333 10.7333 17.4833 11.1583 16.5 11.725C15.5167 12.2917 14.6167 12.9833 13.8 13.8C12.9833 14.6167 12.2917 15.5167 11.725 16.5C11.1583 17.4833 10.7333 18.5333 10.45 19.65C10.4167 19.75 10.3583 19.8333 10.275 19.9C10.1917 19.9667 10.1 20 10 20Z"
      fill="white"
    />
  </svg>
);

export default GeminiFill;